module.exports = __webpack_public_path__ + "static/img/logo.aaaa963d.png";